package org.maplibre.compose.expressions.ast

import org.maplibre.compose.expressions.value.FloatValue

/** Resolves text units and images when compiling an [Expression]. */
internal interface ExpressionContext {
  /** The scale factor to convert EMs to the desired unit */
  val emScale: Expression<FloatValue>

  /** The scale factor to convert SPs to the desired unit */
  val spScale: Expression<FloatValue>

  /** The scale factor to convert DP text offsets to the desired text unit. */
  val dpScale: Expression<FloatValue>
    get() = error("DP text offsets are not allowed in this context")

  /** @return the resolved identifier for the [bitmap]. */
  fun resolveBitmap(bitmap: BitmapLiteral): String

  /** @return the resolved identifier for the [painter]. */
  fun resolvePainter(painter: PainterLiteral): String

  /** A context where no complex types can be resolved. */
  object None : ExpressionContext {
    override val emScale: Expression<FloatValue>
      get() = error("TextUnit not allowed in this context")

    override val spScale: Expression<FloatValue>
      get() = error("TextUnit not allowed in this context")

    override fun resolveBitmap(bitmap: BitmapLiteral): String =
      error("Bitmap not allowed in this context")

    override fun resolvePainter(painter: PainterLiteral): String =
      error("Painter not allowed in this context")
  }
}
